import { ViewHook } from "phoenix_live_view";
import "number-flow";

import { pageLocale } from "../utils/formatters";

import type NumberFlow from "number-flow";

class ReportHighlights extends ViewHook {
  declare slides: HTMLElement[];
  declare ticks: HTMLElement[];
  declare counter: HTMLElement;
  declare flow: NumberFlow;
  declare index: number;
  declare autoplay: boolean;

  mounted() {
    this.slides = [...this.el.querySelectorAll<HTMLElement>('[data-part="slide"]')];
    this.ticks = [...this.el.querySelectorAll<HTMLElement>('[data-part="tick"]')];
    this.counter = this.el.querySelector<HTMLElement>('[data-part="counter"]')!;
    this.autoplay = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.index = 0;

    this.flow = document.createElement("number-flow");
    this.flow.locales = pageLocale();
    this.flow.spinTiming = { duration: 1000, easing: "cubic-bezier(0.16, 1, 0.3, 1)" };
    this.el.querySelector('[data-part="value"]')!.replaceChildren(this.flow);

    this.onTickEnd = this.onTickEnd.bind(this);
    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);

    this.ticks.forEach((tick, index) => {
      tick.addEventListener("click", () => this.show(index));
      tick.addEventListener("animationend", this.onTickEnd);
    });

    this.el.addEventListener("pointerenter", this.onPointerEnter);
    this.el.addEventListener("pointerleave", this.onPointerLeave);

    this.flow.animated = false;
    this.show(0);
    this.flow.animated = true;
  }

  destroyed() {
    this.el.removeEventListener("pointerenter", this.onPointerEnter);
    this.el.removeEventListener("pointerleave", this.onPointerLeave);
  }

  private show(index: number) {
    this.index = index;

    this.slides.forEach((slide, i) => this.toggle(slide, "active", i === index));
    this.ticks.forEach((tick, i) => {
      this.toggle(tick, "done", i < index || (!this.autoplay && i === index));
      this.toggle(tick, "active", false);
    });

    if (this.autoplay) {
      void this.ticks[index].offsetWidth;
      this.toggle(this.ticks[index], "active", true);
    }

    this.counter.textContent = `${String(index + 1).padStart(2, "0")} / ${String(this.slides.length).padStart(2, "0")}`;

    const { value, prefix, suffix, decimals } = this.slides[index].dataset;
    const digits = Number(decimals);

    this.flow.format = { minimumFractionDigits: digits, maximumFractionDigits: digits };
    this.flow.numberPrefix = prefix ?? "";
    this.flow.numberSuffix = suffix ?? "";
    this.flow.update(Number(value));
  }

  private toggle(el: HTMLElement, key: "active" | "done", on: boolean) {
    if (on) {
      el.dataset[key] = "";
    } else {
      delete el.dataset[key];
    }
  }

  private onTickEnd() {
    this.show((this.index + 1) % this.slides.length);
  }

  private onPointerEnter() {
    this.el.dataset.paused = "";
  }

  private onPointerLeave() {
    delete this.el.dataset.paused;
  }
}

export default ReportHighlights;
